import { CurriculumAdapter } from './types';
import { musicAdapter } from './musicAdapter';
import { aiAdapter } from './aiAdapter';
import { aiFall2025Adapter } from './aiFall2025Adapter';
import { aiCreateWorlds2026Adapter } from './aiCreateWorlds2026Adapter';
import { musicWinter2026Adapter } from './musicWinter2026Adapter';
import { scaffoldedCurricula } from '../managedCurricula';

const scaffoldAdapter = (curriculum: typeof scaffoldedCurricula[number]): CurriculumAdapter => ({
  id: curriculum.id,
  levels: curriculum.levels,
  getLevelById: (id) => curriculum.levels.find((level) => level.id === id),
  getLevelIndex: (id) => curriculum.levels.findIndex((level) => level.id === id),
  getLevelStatus: (levelId, currentLevelId, completedIds) =>
    completedIds.includes(levelId) ? 'completed' : levelId === currentLevelId ? 'next' : 'upcoming',
  getShortLevelName: (title) => title.replace(/^Class\s+\d+:\s*/i, ''),
  getMissionActivity: (missionId) => curriculum.levels.flatMap((level) => level.missions || []).find((mission) => mission.id === missionId),
});

const REGISTRY: Record<string, CurriculumAdapter> = {
  music: musicAdapter,
  ai: aiAdapter,
  'ai-fall-2025': aiFall2025Adapter,
  'ai-2026-create-worlds': aiCreateWorlds2026Adapter,
  // New seasonal music curriculum with mission goals
  musicwinter2026: musicWinter2026Adapter,
  ...Object.fromEntries(scaffoldedCurricula.map((curriculum) => [curriculum.id, scaffoldAdapter(curriculum)])),
};

export function getCurriculumAdapterById(id?: string | null): CurriculumAdapter {
  const key = (id || 'music').trim().toLowerCase();
  return REGISTRY[key] || musicAdapter;
}

export function listCurriculumAdapters(): CurriculumAdapter[] {
  return Object.values(REGISTRY);
}
